module.exports = "/_next/static/images/d183f29c1f634e8801323d7d53544f07-apple-pay.png.webp";